import { Input, Modal, Spin } from "antd";
import React, { useState } from "react";
import {
  Control,
  Controller,
  FieldError,
  UseFormHandleSubmit,
} from "react-hook-form";
import { IoMdClose } from "react-icons/io";
import { FiSave } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

type ChangePasswordModalProps = {
  visible: boolean;
  handleCancel: () => void;
  onSubmitPassword: (data: any) => void;
  handleSubmit: UseFormHandleSubmit<{
    current_password: string;
    new_password: string;
    comfirm_password: string;
  }>;
  control: Control<
    {
      current_password: string;
      new_password: string;
      comfirm_password: string;
    },
    object
  >;
  errors: {
    current_password?: FieldError | undefined;
    new_password?: FieldError | undefined;
    comfirm_password?: FieldError | undefined;
  };
  isPasswordCompared: boolean;
  spinloading: boolean;
};

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  visible,
  handleCancel,
  onSubmitPassword,
  handleSubmit,
  control,
  errors,
  isPasswordCompared,
  spinloading,
}) => {
  const { t } = useTranslation(["translation"]);
  const [currentPasswordType, setCurrentPasswordType] = useState(false);
  const [newPasswordType, setNewPasswordType] = useState(false);
  const [confirmPasswordType, setConfirmPasswordType] = useState(false);
  
  const onChangIcon = (type: string) => {
    const passwordType = type;
    if (passwordType === "current") {
      setCurrentPasswordType(!currentPasswordType);
    } else if (passwordType === "new") {
      setNewPasswordType(!newPasswordType);
    } else if (passwordType === "confirm") {
      setConfirmPasswordType(!confirmPasswordType);
    }
  }

  return (
    <Modal
      closeIcon={<IoMdClose />}
      className="modal-password"
      width={800}
      visible={visible}
      footer={false}
      onCancel={handleCancel}
      zIndex={90000}
    >
      <Spin spinning={spinloading} tip="Loading...">
        <form onSubmit={handleSubmit(onSubmitPassword)}>
          <div className="input-change-password-container">
            <p className="text-header">{t("Change Password")}</p>
            <div className="main-input-change-container">
              <div className="input-container">
                <Row style={{ width: '100%' }}>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} style={{ padding: '2px 12px' }}>
                    <div className="text-container">
                      <p className="text-label">
                        Current Password : <span>*</span>
                      </p>
                      <p className="text-desc">รหัสผ่านปัจจุบัน :</p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={9} lg={9} xl={9} style={{ padding: '2px 0 2px 12px' }}>
                    <Controller
                      name="current_password"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <div className="input-password-container">
                          <input
                            {...field}
                            type={currentPasswordType === false ? "password" : "text"}
                            className={`input-password ${errors.current_password ? "invalid" : ""
                              }`}
                          />
                          <div className="current-password-modal">
                            {currentPasswordType === false ? <FaEyeSlash onClick={() => onChangIcon("current")}/> : <FaEye onClick={() => onChangIcon("current")}/>}
                          </div>
                          {errors.current_password && (
                            <p className="text-error">กรุณากรอกข้อมูล</p>
                          )}
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              </div>

              <div className="input-container">
                <Row style={{ width: '100%' }}>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} style={{ padding: '2px 12px' }}>
                    <div className="text-container">
                      <p className="text-label">
                        New Password : <span>*</span>
                      </p>
                      <p className="text-desc">รหัสผ่านใหม่ :</p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={9} lg={9} xl={9} style={{ padding: '2px 0 2px 12px' }}>
                    <Controller
                      name="new_password"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <div className="input-password-container">
                          <input
                            {...field}
                            type={newPasswordType === false ? "password" : "text"}
                            className={`input-password ${errors.new_password ? "invalid" : ""
                              }`}
                          />
                          <div className="current-password-modal">
                            {newPasswordType === false ? <FaEyeSlash onClick={() => onChangIcon("new")}/> : <FaEye onClick={() => onChangIcon("new")}/>}
                          </div>
                          {errors.new_password && (
                            <p className="text-error">กรุณากรอกข้อมูล</p>
                          )}
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              </div>

              <div className="input-container">
                <Row style={{ width: '100%' }}>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} style={{ padding: '2px 12px' }}>
                    <div className="text-container">
                      <p className="text-label">
                        Confirm Password : <span>*</span>
                      </p>
                      <p className="text-desc">ยืนยันรหัสผ่าน :</p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={9} lg={9} xl={9} style={{ padding: '2px 0 2px 12px' }}>
                    <Controller
                      name="comfirm_password"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <div className="input-password-container">
                          <input
                            {...field}
                            type={confirmPasswordType === false ? "password" : "text"}
                            className={`input-password ${errors.comfirm_password || !isPasswordCompared
                              ? "invalid"
                              : ""
                              }`}
                          />
                          <div className="current-password-modal">
                            {confirmPasswordType === false ? <FaEyeSlash onClick={() => onChangIcon("confirm")}/> : <FaEye onClick={() => onChangIcon("confirm")}/>}
                          </div>
                          {errors.comfirm_password && (
                            <p className="text-error">กรุณากรอกข้อมูล</p>
                          )}
                          {!isPasswordCompared && (
                            <p className="text-error">กรุณากรอกรหัสผ่านให้ตรงกัน</p>
                          )}
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <div className="button-container" style={{ padding: '0 12px' }}>
              <button
                className="button-cancle"
                type="button"
                onClick={handleCancel}
              >
                Close
              </button>

              <button className="button-save" type="submit">
                <FiSave />
                Save
              </button>
            </div>
          </div>
        </form>
      </Spin>
    </Modal >
  );
};

export default ChangePasswordModal;
